"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DictionaryFields = exports.FieldCode = exports.FieldValidTo = exports.FieldValidFrom = exports.FieldActive = exports.FieldName = exports.FieldOrder = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const form_text_field_1 = require("../../form/fields/form-text-field");
const form_number_field_1 = require("../../form/fields/form-number-field");
const form_checkbox_1 = require("../../form/fields/form-checkbox");
const form_date_time_field_1 = require("../../form/fields/form-date-time-field");
const authored_fields_1 = require("../authored-evidence/authored-fields");
function FieldOrder() {
    const intl = react_intl_1.useIntl();
    return (react_1.default.createElement(form_number_field_1.FormNumberField, { name: "order", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_EVIDENCE_FIELD_LABEL_ORDER", defaultMessage: "Po\u0159ad\u00ED" }), helpLabel: intl.formatMessage({
            id: 'EAS_EVIDENCE_FIELD_HELP_ORDER',
            defaultMessage: ' ',
        }) }));
}
exports.FieldOrder = FieldOrder;
function FieldName() {
    const intl = react_intl_1.useIntl();
    return (react_1.default.createElement(form_text_field_1.FormTextField, { name: "name", required: true, autoFocus: true, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_EVIDENCE_FIELD_LABEL_NAME", defaultMessage: "N\u00E1zev" }), helpLabel: intl.formatMessage({
            id: 'EAS_EVIDENCE_FIELD_HELP_NAME',
            defaultMessage: ' ',
        }) }));
}
exports.FieldName = FieldName;
function FieldActive() {
    const intl = react_intl_1.useIntl();
    return (react_1.default.createElement(form_checkbox_1.FormCheckbox, { name: "active", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_EVIDENCE_FIELD_LABEL_ACTIVE", defaultMessage: "Aktivn\u00ED" }), helpLabel: intl.formatMessage({
            id: 'EAS_EVIDENCE_FIELD_HELP_ACTIVE',
            defaultMessage: ' ',
        }), disabled: true }));
}
exports.FieldActive = FieldActive;
function FieldValidFrom() {
    const intl = react_intl_1.useIntl();
    return (react_1.default.createElement(form_date_time_field_1.FormDateTimeField, { name: "validFrom", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_EVIDENCE_FIELD_LABEL_VALID_FROM", defaultMessage: "Platn\u00FD od" }), helpLabel: intl.formatMessage({
            id: 'EAS_EVIDENCE_FIELD_HELP_VALID_FROM',
            defaultMessage: ' ',
        }) }));
}
exports.FieldValidFrom = FieldValidFrom;
function FieldValidTo() {
    const intl = react_intl_1.useIntl();
    return (react_1.default.createElement(form_date_time_field_1.FormDateTimeField, { name: "validTo", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_EVIDENCE_FIELD_LABEL_VALID_TO", defaultMessage: "Platn\u00FD do" }), helpLabel: intl.formatMessage({
            id: 'EAS_EVIDENCE_FIELD_HELP_VALID_TO',
            defaultMessage: ' ',
        }) }));
}
exports.FieldValidTo = FieldValidTo;
function FieldCode() {
    const intl = react_intl_1.useIntl();
    return (react_1.default.createElement(form_text_field_1.FormTextField, { name: "code", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_EVIDENCE_FIELD_LABEL_CODE", defaultMessage: "K\u00F3d" }), helpLabel: intl.formatMessage({
            id: 'EAS_EVIDENCE_FIELD_HELP_CODE',
            defaultMessage: ' ',
        }) }));
}
exports.FieldCode = FieldCode;
function DictionaryFields(options) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(FieldOrder, null),
        react_1.default.createElement(FieldName, null),
        react_1.default.createElement(FieldActive, null),
        options.FieldsComponent && react_1.default.createElement(options.FieldsComponent, null),
        react_1.default.createElement(FieldValidFrom, null),
        react_1.default.createElement(FieldValidTo, null),
        react_1.default.createElement(FieldCode, null),
        react_1.default.createElement(authored_fields_1.AuthoredFields, null)));
}
exports.DictionaryFields = DictionaryFields;
//# sourceMappingURL=dictionary-fields.js.map